(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":17}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":18}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":19}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };
},{"core-js/library/fn/object/get-own-property-descriptor":20}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":21}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":22}],7:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/values"), __esModule: true };
},{"core-js/library/fn/object/values":23}],8:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":24}],9:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":25}],10:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],11:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":3}],12:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":1}],13:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _getPrototypeOf = require("../core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = require("../core-js/object/get-own-property-descriptor");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};
},{"../core-js/object/get-own-property-descriptor":4,"../core-js/object/get-prototype-of":5}],14:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":2,"../core-js/object/set-prototype-of":6,"../helpers/typeof":16}],15:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":16}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":8,"../core-js/symbol/iterator":9}],17:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":31,"../../modules/es6.object.assign":86}],18:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

},{"../../modules/_core":31,"../../modules/es6.object.create":87}],19:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

},{"../../modules/_core":31,"../../modules/es6.object.define-property":88}],20:[function(require,module,exports){
require('../../modules/es6.object.get-own-property-descriptor');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};

},{"../../modules/_core":31,"../../modules/es6.object.get-own-property-descriptor":89}],21:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;

},{"../../modules/_core":31,"../../modules/es6.object.get-prototype-of":90}],22:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;

},{"../../modules/_core":31,"../../modules/es6.object.set-prototype-of":91}],23:[function(require,module,exports){
require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;

},{"../../modules/_core":31,"../../modules/es7.object.values":95}],24:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":31,"../../modules/es6.object.to-string":92,"../../modules/es6.symbol":94,"../../modules/es7.symbol.async-iterator":96,"../../modules/es7.symbol.observable":97}],25:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":83,"../../modules/es6.string.iterator":93,"../../modules/web.dom.iterable":98}],26:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],27:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],28:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":47}],29:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":75,"./_to-iobject":77,"./_to-length":78}],30:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],31:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],32:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":26}],33:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],34:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":39}],35:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":40,"./_is-object":47}],36:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],37:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":61,"./_object-keys":64,"./_object-pie":65}],38:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":31,"./_ctx":32,"./_global":40,"./_has":41,"./_hide":42}],39:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],40:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],41:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],42:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":34,"./_object-dp":56,"./_property-desc":68}],43:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":40}],44:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":34,"./_dom-create":35,"./_fails":39}],45:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":30}],46:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":30}],47:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],48:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":42,"./_object-create":55,"./_property-desc":68,"./_set-to-string-tag":71,"./_wks":84}],49:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":38,"./_hide":42,"./_iter-create":48,"./_iterators":51,"./_library":52,"./_object-gpo":62,"./_redefine":69,"./_set-to-string-tag":71,"./_wks":84}],50:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],51:[function(require,module,exports){
module.exports = {};

},{}],52:[function(require,module,exports){
module.exports = true;

},{}],53:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":39,"./_has":41,"./_is-object":47,"./_object-dp":56,"./_uid":81}],54:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":34,"./_fails":39,"./_iobject":45,"./_object-gops":61,"./_object-keys":64,"./_object-pie":65,"./_to-object":79}],55:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":28,"./_dom-create":35,"./_enum-bug-keys":36,"./_html":43,"./_object-dps":57,"./_shared-key":72}],56:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":28,"./_descriptors":34,"./_ie8-dom-define":44,"./_to-primitive":80}],57:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":28,"./_descriptors":34,"./_object-dp":56,"./_object-keys":64}],58:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":34,"./_has":41,"./_ie8-dom-define":44,"./_object-pie":65,"./_property-desc":68,"./_to-iobject":77,"./_to-primitive":80}],59:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":60,"./_to-iobject":77}],60:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":36,"./_object-keys-internal":63}],61:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],62:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":41,"./_shared-key":72,"./_to-object":79}],63:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":29,"./_has":41,"./_shared-key":72,"./_to-iobject":77}],64:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":36,"./_object-keys-internal":63}],65:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],66:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":31,"./_export":38,"./_fails":39}],67:[function(require,module,exports){
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

},{"./_descriptors":34,"./_object-keys":64,"./_object-pie":65,"./_to-iobject":77}],68:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],69:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":42}],70:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":28,"./_ctx":32,"./_is-object":47,"./_object-gopd":58}],71:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":41,"./_object-dp":56,"./_wks":84}],72:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":73,"./_uid":81}],73:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":31,"./_global":40,"./_library":52}],74:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":33,"./_to-integer":76}],75:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":76}],76:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],77:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":33,"./_iobject":45}],78:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":76}],79:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":33}],80:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":47}],81:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],82:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":31,"./_global":40,"./_library":52,"./_object-dp":56,"./_wks-ext":83}],83:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":84}],84:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":40,"./_shared":73,"./_uid":81}],85:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":27,"./_iter-define":49,"./_iter-step":50,"./_iterators":51,"./_to-iobject":77}],86:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":38,"./_object-assign":54}],87:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":38,"./_object-create":55}],88:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":34,"./_export":38,"./_object-dp":56}],89:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":58,"./_object-sap":66,"./_to-iobject":77}],90:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":62,"./_object-sap":66,"./_to-object":79}],91:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":38,"./_set-proto":70}],92:[function(require,module,exports){

},{}],93:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":49,"./_string-at":74}],94:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":28,"./_descriptors":34,"./_enum-keys":37,"./_export":38,"./_fails":39,"./_global":40,"./_has":41,"./_hide":42,"./_is-array":46,"./_is-object":47,"./_library":52,"./_meta":53,"./_object-create":55,"./_object-dp":56,"./_object-gopd":58,"./_object-gopn":60,"./_object-gopn-ext":59,"./_object-gops":61,"./_object-keys":64,"./_object-pie":65,"./_property-desc":68,"./_redefine":69,"./_set-to-string-tag":71,"./_shared":73,"./_to-iobject":77,"./_to-object":79,"./_to-primitive":80,"./_uid":81,"./_wks":84,"./_wks-define":82,"./_wks-ext":83}],95:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":38,"./_object-to-array":67}],96:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":82}],97:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":82}],98:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":40,"./_hide":42,"./_iterators":51,"./_wks":84,"./es6.array.iterator":85}],99:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonUi = require('@amberhps/common-ui');

var _PatientDashboard = require('./views/PatientDashboard');

var _PatientDashboard2 = _interopRequireDefault(_PatientDashboard);

var _FilterSearchUsers = require('./views/filterSearch/FilterSearchUsers');

var _FilterSearchUsers2 = _interopRequireDefault(_FilterSearchUsers);

var _PatientFilteringProvider = require('./views/PatientFilteringProvider');

var _PatientFilteringProvider2 = _interopRequireDefault(_PatientFilteringProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Application setup
 *
 * @class App
 */


// Shared
var App = function App() {
    var _this = this;

    (0, _classCallCheck3.default)(this, App);

    // Password Strength Indication
    this.passwordStrengthIndicator = new _commonUi.PasswordStrengthIndicator((0, _jquery2.default)('.js-passwordStrengthIndicator'));

    this.inputMasks = [];
    this.forms = [];
    this.tooltips = [];
    this.accordions = [];
    this.mobileAccordions = [];
    (0, _jquery2.default)('.js-inputMask').each(function (i, el) {
        _this.inputMasks[i] = new _commonUi.InputMask(el);
    });
    (0, _jquery2.default)('form').each(function (i, el) {
        _this.forms[i] = new _commonUi.Form(el);
    });
    (0, _jquery2.default)('.js-accordion').each(function (i, el) {
        _this.accordions[i] = new _commonUi.Accordion(el, false);
    });
    (0, _jquery2.default)('.js-mobile-accordion').each(function (i, el) {
        _this.mobileAccordions[i] = new _commonUi.Accordion(el, true);
    });

    if ((0, _jquery2.default)('.js-patient-dashboard').length) {
        var $el = (0, _jquery2.default)('.js-patient-dashboard');
        this.patientDashboard = new _PatientDashboard2.default($el);
    }

    if ((0, _jquery2.default)('.js-patientFiltering').length) {
        var _$el = (0, _jquery2.default)('.js-patientFiltering');
        this.patientFilteringProvider = new _PatientFilteringProvider2.default(_$el);
    }

    // Form Notification
    if ((0, _jquery2.default)('.js-form-notification').length) {
        (0, _jquery2.default)('.js-form-notification').focus();
    }

    (0, _jquery2.default)('.tooltip').each(function (i, el) {
        _this.tooltips[i] = new _commonUi.Tooltip(el);
    });

    if ((0, _jquery2.default)('.js-filterSearchUsers').length) {
        var _$el2 = (0, _jquery2.default)('.js-filterSearchUsers');
        this.FilterSearchUsers = new _FilterSearchUsers2.default(_$el2);
    }

    this.mobileNav = new _commonUi.MobileNav((0, _jquery2.default)('.menu-mobile'));

    // Modal
    this.modals = [];
    (0, _jquery2.default)('.js-modal').each(function (i, el) {
        _this.modals[i] = new _commonUi.Modal(el);
    });

    // Inactivity Modal
    if (window.GLOBAL.TOKEN_EXPIRATION !== 0) {
        this.inactivityModal = new _commonUi.InactivityModal((0, _jquery2.default)('#inactivity-modal'));
    }

    if ('.js-unsavedChanges') {
        this.unsavedChangesModal = new _commonUi.UnsavedChangesModal();
    }

    if ((0, _jquery2.default)('.js-chat').length) {
        this.chatModal = new _commonUi.ChatModal((0, _jquery2.default)('.js-chat'));
    }

    this.notificationsModals = [];
    (0, _jquery2.default)('[id^=\'js-notification-modal-\']').each(function (i, el) {
        _this.notificationsModals[i] = new _commonUi.Modal(el);
    });

    this.deactivationModals = [];
    (0, _jquery2.default)('[id^=\'js-deactivate-modal-\']').each(function (i, el) {
        _this.deactivationModals[i] = new _commonUi.Modal(el);
    });

    this.activationModals = [];
    (0, _jquery2.default)('[id^=\'js-activate-modal-\']').each(function (i, el) {
        _this.activationModals[i] = new _commonUi.Modal(el);
    });

    // Password Toggle
    this.passwordToggles = [];
    (0, _jquery2.default)('.js-passwordToggle').each(function (i, el) {
        _this.passwordToggles[i] = new _commonUi.PasswordToggle(el);
    });
};

// Site specific


exports.default = App;

},{"./views/PatientDashboard":101,"./views/PatientFilteringProvider":102,"./views/filterSearch/FilterSearchUsers":105,"@amberhps/common-ui":"@amberhps/common-ui","babel-runtime/helpers/classCallCheck":10,"jquery":"jquery"}],100:[function(require,module,exports){
'use strict';

var _App = require('App');

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _App2.default();

},{"App":99}],101:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _FilterSearchPrescriptions = require('./filterSearch/FilterSearchPrescriptions');

var _FilterSearchPrescriptions2 = _interopRequireDefault(_FilterSearchPrescriptions);

var _FilterSearchReferrals = require('./filterSearch/FilterSearchReferrals');

var _FilterSearchReferrals2 = _interopRequireDefault(_FilterSearchReferrals);

var _commonUi = require('@amberhps/common-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PatientDashboard = function PatientDashboard($el) {
    (0, _classCallCheck3.default)(this, PatientDashboard);

    this.$el = $el;

    this.filterSearchReferrals = new _FilterSearchReferrals2.default((0, _jquery2.default)('.js-filterSearchReferrals'));

    this.filterSearchPrescriptions = new _FilterSearchPrescriptions2.default((0, _jquery2.default)('.js-filterSearchPrescriptions'));

    this.sorting = new _commonUi.Sorting((0, _jquery2.default)('.js-sorting'));
    this.tabs = new _commonUi.Tabs((0, _jquery2.default)('.js-tabs'));
    this.addNote = new _commonUi.AddNote((0, _jquery2.default)('.js-addNote'));
    this.historySelector = new _commonUi.HistorySelector((0, _jquery2.default)('.js-historySelector'));
};

exports.default = PatientDashboard;

},{"./filterSearch/FilterSearchPrescriptions":103,"./filterSearch/FilterSearchReferrals":104,"@amberhps/common-ui":"@amberhps/common-ui","babel-runtime/helpers/classCallCheck":10,"jquery":"jquery"}],102:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonUi = require('@amberhps/common-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_SETTINGS = {
    PAGINATION: 20
};

/* Extends PatientFiltering shared file with specific provider options */

var PatientFilteringManagedCare = function (_PatientFiltering) {
    (0, _inherits3.default)(PatientFilteringManagedCare, _PatientFiltering);

    function PatientFilteringManagedCare(el) {
        (0, _classCallCheck3.default)(this, PatientFilteringManagedCare);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PatientFilteringManagedCare.__proto__ || (0, _getPrototypeOf2.default)(PatientFilteringManagedCare)).call(this, el));

        _this.filters = {
            filterByActive: false,
            filterByNewNotes: false,
            filterByPriorAuthorizationStatus: false,
            filterByProvider: null
        };
        return _this;
    }

    (0, _createClass3.default)(PatientFilteringManagedCare, [{
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onFilterDropdownChangeHandler = this.onFilterDropdownChange.bind(this);
            (0, _get3.default)(PatientFilteringManagedCare.prototype.__proto__ || (0, _getPrototypeOf2.default)(PatientFilteringManagedCare.prototype), 'setupHandlers', this).call(this);
        }
    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$filterDropdown = this.$el.find('.js-patientFiltering-filterDropdown');
            (0, _get3.default)(PatientFilteringManagedCare.prototype.__proto__ || (0, _getPrototypeOf2.default)(PatientFilteringManagedCare.prototype), 'createChildren', this).call(this);
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.$filterDropdown.on('change', this.onFilterDropdownChangeHandler);
            (0, _get3.default)(PatientFilteringManagedCare.prototype.__proto__ || (0, _getPrototypeOf2.default)(PatientFilteringManagedCare.prototype), 'enable', this).call(this);
        }

        /*
         * Handle filter dropdown change event
         *
         * @method onFilterDropdownChange
         * @private
         */

    }, {
        key: 'onFilterDropdownChange',
        value: function onFilterDropdownChange() {
            this.setActiveFilterOption();
        }

        /*
         * Set active option of filter dropdown
         *
         * @method setActiveFilterOption
         * @private
         */

    }, {
        key: 'setActiveFilterOption',
        value: function setActiveFilterOption() {
            var optionSelected = this.$filterDropdown.find('option:selected');
            this.filters.filterByProvider = optionSelected.val();
            (0, _get3.default)(PatientFilteringManagedCare.prototype.__proto__ || (0, _getPrototypeOf2.default)(PatientFilteringManagedCare.prototype), 'searchPatients', this).call(this, 1);
        }

        /*
         * Get specific options to filter by for search
         *
         * @method getSearchOptions
         * @private
         * @param {number} - page number to return results for
         */

    }, {
        key: 'getSearchOptions',
        value: function getSearchOptions(page) {
            return {
                searchString: this.searchQuery,
                filterByNewNotes: this.filters.filterByNewNotes,
                filterByPriorAuthorizationStatus: this.filters.filterByPriorAuthorizationStatus,
                filterByProcessingReferrals: this.filters.filterByProcessingReferrals,
                filterByProvider: this.filters.filterByProvider,
                page: page,
                paginationAmount: API_SETTINGS.PAGINATION
            };
        }
    }]);
    return PatientFilteringManagedCare;
}(_commonUi.PatientFiltering);

exports.default = PatientFilteringManagedCare;

},{"@amberhps/common-ui":"@amberhps/common-ui","babel-runtime/core-js/object/get-prototype-of":5,"babel-runtime/helpers/classCallCheck":10,"babel-runtime/helpers/createClass":11,"babel-runtime/helpers/get":13,"babel-runtime/helpers/inherits":14,"babel-runtime/helpers/possibleConstructorReturn":15,"jquery":"jquery"}],103:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonUi = require('@amberhps/common-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILTER_FIELDS = {
    PRESCRIPTION_NUMBER: 'prescription-number',
    PRESCRIPTION_NAME: 'prescription-name',
    PRESCRIPTION_NDC_NUMBER: 'prescription-ndc-number',
    PRESCRIPTION_DIAGNOSTIC_CODE: 'prescription-diagnostic-code',
    PRESCRIPTION_DIAGNOSTIC_NAME: 'prescription-diagnostic-name',
    PRESCRIPTION_STATUS: 'prescription-status',
    PRESCRIPTION_PRESCRIBER: 'prescription-prescriber'
};

var STATE_CLASSES = {
    HIDDEN: 'isHidden'
};

/* Extends FilterSearch shared file with specific provider options for prescriptions */

var FilterSearchPrescriptions = function (_FilterSearch) {
    (0, _inherits3.default)(FilterSearchPrescriptions, _FilterSearch);

    function FilterSearchPrescriptions() {
        (0, _classCallCheck3.default)(this, FilterSearchPrescriptions);
        return (0, _possibleConstructorReturn3.default)(this, (FilterSearchPrescriptions.__proto__ || (0, _getPrototypeOf2.default)(FilterSearchPrescriptions)).apply(this, arguments));
    }

    (0, _createClass3.default)(FilterSearchPrescriptions, [{
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onStatusDropdownChangeHandler = this.onStatusDropdownChange.bind(this);
            (0, _get3.default)(FilterSearchPrescriptions.prototype.__proto__ || (0, _getPrototypeOf2.default)(FilterSearchPrescriptions.prototype), 'setupHandlers', this).call(this);
        }
    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$statusDropdown = this.$el.find('.js-filterSearch-statusDropdown');
            (0, _get3.default)(FilterSearchPrescriptions.prototype.__proto__ || (0, _getPrototypeOf2.default)(FilterSearchPrescriptions.prototype), 'createChildren', this).call(this);
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.$statusDropdown.on('change', this.onStatusDropdownChangeHandler);
            (0, _get3.default)(FilterSearchPrescriptions.prototype.__proto__ || (0, _getPrototypeOf2.default)(FilterSearchPrescriptions.prototype), 'enable', this).call(this);
        }

        /*
         * Handles change event on status filter dropdown
         *
         * @method onStatusDropdownChange
         * @public
         */

    }, {
        key: 'onStatusDropdownChange',
        value: function onStatusDropdownChange() {
            this.checkSelectedStatus(this.filterFields);
        }

        /*
         * Returns active option in filter by status dropdown
         *
         * @method getActiveFilterStatus
         * @public
         * @return value of active status filter option
         */

    }, {
        key: 'getActiveFilterStatus',
        value: function getActiveFilterStatus() {
            var $selectedOption = this.$statusDropdown.find('option:selected');
            return $selectedOption.val().toLowerCase();
        }

        /*
         * Check if results should be filtered by status and search term or just status
         *
         * @method checkSelectedStatus
         * @public
         */

    }, {
        key: 'checkSelectedStatus',
        value: function checkSelectedStatus() {
            var statusFilter = this.getActiveFilterStatus();

            if (!this.searchQuery && statusFilter) {
                var matchedStatusResults = this.filterByStatus(this.searchFields);
                this.updateResults(matchedStatusResults);
            } else {
                this.filterResults();
            }
        }

        /*
         * Searches status field for exact match to value of selected filter by status option
         *
         * @method filterByStatus
         * @public
         * @param filterList {array} of objects to filter
         */

    }, {
        key: 'filterByStatus',
        value: function filterByStatus(filterList) {
            var statusFilter = this.getActiveFilterStatus();
            var matchedResults = filterList.filter(function (listItem) {
                var statusValue = String(listItem.prescriptionStatus).toLowerCase();
                var isMatch = statusValue.indexOf(statusFilter, 0) === 0;
                return isMatch;
            });

            return matchedResults;
        }

        /*
         * Overrides Filter Results method in base class with ability to check
         * whether additional filtering by status needs to take place
         *
         * @method filterResults
         * @public
         */

    }, {
        key: 'filterResults',
        value: function filterResults() {
            var _this2 = this;

            var statusFilter = this.getActiveFilterStatus();

            if (!this.searchQuery && !statusFilter) {
                this.resetSearch();
                return;
            }

            var matchedSearchResults = this.searchFields.filter(function (listItem) {
                var query = ('' + _this2.searchQuery).replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
                var pattern = new RegExp('\\b' + query);
                var searchableObject = (0, _extends3.default)({}, listItem);

                var _a = (0, _values2.default)(searchableObject);

                var _f = function _f(value) {
                    return String(value).toLowerCase();
                };

                var _r = [];

                for (var _i = 0; _i < _a.length; _i++) {
                    _r.push(_f(_a[_i], _i, _a));
                }

                return _r.some(function (value) {
                    return pattern.test(value);
                });
            });

            /* eslint-disable max-len */
            var matchedResults = statusFilter ? this.filterByStatus(matchedSearchResults) : matchedSearchResults;
            /* eslint-enable max-len */

            this.updateResults(matchedResults);
        }

        /*
         * Shows and hides content after being filtered
         *
         * @method updateResults
         * @public
         * @param matchedResults {array} of mmatching list items
         */

    }, {
        key: 'updateResults',
        value: function updateResults(matchedResults) {
            if (matchedResults.length !== 0) {
                this.showMatchedResults(matchedResults);
            } else {
                this.showNoResultsMessage();
            }
        }

        /*
         * Creates a reference to all prescriptions and the searchable fields
         *
         * @method createSearchableList
         * @public
         */

    }, {
        key: 'createSearchableList',
        value: function createSearchableList() {
            var _this3 = this;

            var prescriptions = document.querySelectorAll('.js-filterSearchPrescriptions .js-filterSearch-item');

            var _a2 = prescriptions;

            var _f2 = function _f2(prescription) {
                var $prescription = (0, _jquery2.default)(prescription);

                var prescriptionName = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_NAME + ']').data(FILTER_FIELDS.PRESCRIPTION_NAME);
                var prescriptionNumber = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_NUMBER + ']').data(FILTER_FIELDS.PRESCRIPTION_NUMBER);
                var prescriptionNDCNumber = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_NDC_NUMBER + ']').data(FILTER_FIELDS.PRESCRIPTION_NDC_NUMBER);
                var prescriptionDiagnosticCode = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_DIAGNOSTIC_CODE + ']').data(FILTER_FIELDS.PRESCRIPTION_DIAGNOSTIC_CODE);
                var prescriptionDiagnosticName = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_DIAGNOSTIC_NAME + ']').data(FILTER_FIELDS.PRESCRIPTION_DIAGNOSTIC_NAME);
                var prescriptionStatus = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_STATUS + ']').data(FILTER_FIELDS.PRESCRIPTION_STATUS);
                var prescriptionPrescriber = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_PRESCRIBER + ']').data(FILTER_FIELDS.PRESCRIPTION_PRESCRIBER);

                /* eslint-disable max-len */
                var searchableFields = {
                    prescriptionName: prescriptionName,
                    prescriptionNumber: prescriptionNumber,
                    prescriptionNDCNumber: prescriptionNDCNumber,
                    prescriptionDiagnosticFullName: prescriptionDiagnosticCode + ' ' + prescriptionDiagnosticName,
                    prescriptionStatus: prescriptionStatus,
                    prescriptionPrescriber: prescriptionPrescriber
                };
                /* eslint-enable max-len */

                _this3.searchFields.push(searchableFields);
            };

            for (var _i2 = 0; _i2 < _a2.length; _i2++) {
                _f2(_a2[_i2], _i2, _a2);
            }

            undefined;
        }

        /*
         * Gets called for every matched result to match and show the list item
         *
         * @method checkMatchedResult
         * @public
         * @param {object} matching result
         */

    }, {
        key: 'checkMatchedResult',
        value: function checkMatchedResult(result) {
            return this.$searchableItems.find('[data-' + FILTER_FIELDS.PRESCRIPTION_NUMBER + '=' + result.prescriptionNumber + ']').parents('.js-filterSearch-item').removeClass(STATE_CLASSES.HIDDEN);
        }
    }]);
    return FilterSearchPrescriptions;
}(_commonUi.FilterSearch);

exports.default = FilterSearchPrescriptions;

},{"@amberhps/common-ui":"@amberhps/common-ui","babel-runtime/core-js/object/get-prototype-of":5,"babel-runtime/core-js/object/values":7,"babel-runtime/helpers/classCallCheck":10,"babel-runtime/helpers/createClass":11,"babel-runtime/helpers/extends":12,"babel-runtime/helpers/get":13,"babel-runtime/helpers/inherits":14,"babel-runtime/helpers/possibleConstructorReturn":15,"jquery":"jquery"}],104:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonUi = require('@amberhps/common-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILTER_FIELDS = {
    PRESCRIPTION_NUMBER: 'prescription-number',
    PRESCRIPTION_NAME: 'prescription-name',
    PRESCRIPTION_NDC_NUMBER: 'prescription-ndc-number',
    PRESCRIPTION_DIAGNOSTIC_CODE: 'prescription-diagnostic-code',
    PRESCRIPTION_DIAGNOSTIC_NAME: 'prescription-diagnostic-name',
    PRESCRIPTION_STATUS: 'prescription-status',
    PRESCRIPTION_PRESCRIBER: 'prescription-prescriber'
};

var STATE_CLASSES = {
    HIDDEN: 'isHidden'
};

/* Extends FilterSearch shared file with specific provider options for prescriptions */

var FilterSearchReferrals = function (_FilterSearch) {
    (0, _inherits3.default)(FilterSearchReferrals, _FilterSearch);

    function FilterSearchReferrals() {
        (0, _classCallCheck3.default)(this, FilterSearchReferrals);
        return (0, _possibleConstructorReturn3.default)(this, (FilterSearchReferrals.__proto__ || (0, _getPrototypeOf2.default)(FilterSearchReferrals)).apply(this, arguments));
    }

    (0, _createClass3.default)(FilterSearchReferrals, [{
        key: 'createSearchableList',


        /*
         * Creates a reference to all prescriptions and the searchable fields
         *
         * @method createSearchableList
         * @public
         */
        value: function createSearchableList() {
            var _this2 = this;

            var prescriptions = document.querySelectorAll('.js-filterSearchReferrals .js-filterSearch-item');

            var _a = prescriptions;

            var _f = function _f(prescription) {
                var $prescription = (0, _jquery2.default)(prescription);

                var prescriptionName = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_NAME + ']').data(FILTER_FIELDS.PRESCRIPTION_NAME);
                var prescriptionNumber = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_NUMBER + ']').data(FILTER_FIELDS.PRESCRIPTION_NUMBER);
                var prescriptionNDCNumber = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_NDC_NUMBER + ']').data(FILTER_FIELDS.PRESCRIPTION_NDC_NUMBER);
                var prescriptionDiagnosticCode = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_DIAGNOSTIC_CODE + ']').data(FILTER_FIELDS.PRESCRIPTION_DIAGNOSTIC_CODE);
                var prescriptionDiagnosticName = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_DIAGNOSTIC_NAME + ']').data(FILTER_FIELDS.PRESCRIPTION_DIAGNOSTIC_NAME);
                var prescriptionStatus = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_STATUS + ']').data(FILTER_FIELDS.PRESCRIPTION_STATUS);
                var prescriptionPrescriber = $prescription.find('[data-' + FILTER_FIELDS.PRESCRIPTION_PRESCRIBER + ']').data(FILTER_FIELDS.PRESCRIPTION_PRESCRIBER);

                /* eslint-disable max-len */
                var searchableFields = {
                    prescriptionName: prescriptionName,
                    prescriptionNumber: prescriptionNumber,
                    prescriptionNDCNumber: prescriptionNDCNumber,
                    prescriptionDiagnosticFullName: prescriptionDiagnosticCode + ' ' + prescriptionDiagnosticName,
                    prescriptionStatus: prescriptionStatus,
                    prescriptionPrescriber: prescriptionPrescriber
                };
                /* eslint-enable max-len */

                _this2.searchFields.push(searchableFields);
            };

            for (var _i = 0; _i < _a.length; _i++) {
                _f(_a[_i], _i, _a);
            }

            undefined;
        }

        /*
         * Gets called for every matched result to match and show the list item
         *
         * @method checkMatchedResult
         * @public
         * @param {object} matching result
         */

    }, {
        key: 'checkMatchedResult',
        value: function checkMatchedResult(result) {
            return this.$searchableItems.find('[data-' + FILTER_FIELDS.PRESCRIPTION_NUMBER + '=' + result.prescriptionNumber + ']').parents('.js-filterSearch-item').removeClass(STATE_CLASSES.HIDDEN);
        }
    }]);
    return FilterSearchReferrals;
}(_commonUi.FilterSearch);

exports.default = FilterSearchReferrals;

},{"@amberhps/common-ui":"@amberhps/common-ui","babel-runtime/core-js/object/get-prototype-of":5,"babel-runtime/helpers/classCallCheck":10,"babel-runtime/helpers/createClass":11,"babel-runtime/helpers/inherits":14,"babel-runtime/helpers/possibleConstructorReturn":15,"jquery":"jquery"}],105:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonUi = require('@amberhps/common-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILTER_FIELDS = {
    USER_NPI_NUMBER: 'user-npi-number',
    USER_NAME: 'user-name',
    USER_EMAIL: 'user-email'
};

var STATE_CLASSES = {
    HIDDEN: 'isHidden'
};

/* Extends FilterSearch shared file with specific provider options for users */

var FilterSearchUsers = function (_FilterSearch) {
    (0, _inherits3.default)(FilterSearchUsers, _FilterSearch);

    function FilterSearchUsers() {
        (0, _classCallCheck3.default)(this, FilterSearchUsers);
        return (0, _possibleConstructorReturn3.default)(this, (FilterSearchUsers.__proto__ || (0, _getPrototypeOf2.default)(FilterSearchUsers)).apply(this, arguments));
    }

    (0, _createClass3.default)(FilterSearchUsers, [{
        key: 'createSearchableList',


        /*
         * Creates a reference to all prescriptions and the searchable fields
         *
         * @method createSearchableList
         * @public
         */
        value: function createSearchableList() {
            var _this2 = this;

            var listItem = document.querySelectorAll('.js-filterSearch-item');

            var _a = listItem;

            var _f = function _f(item) {
                var $item = (0, _jquery2.default)(item);

                var userName = $item.find('[data-' + FILTER_FIELDS.USER_NAME + ']').data(FILTER_FIELDS.USER_NAME);
                var userEmail = $item.find('[data-' + FILTER_FIELDS.USER_EMAIL + ']').data(FILTER_FIELDS.USER_EMAIL);
                var userNpiNumber = $item.find('[data-' + FILTER_FIELDS.USER_NPI_NUMBER + ']').data(FILTER_FIELDS.USER_NPI_NUMBER);

                var searchableFields = {
                    userName: userName,
                    userEmail: userEmail,
                    userNpiNumber: userNpiNumber
                };

                _this2.searchFields.push(searchableFields);
            };

            for (var _i = 0; _i < _a.length; _i++) {
                _f(_a[_i], _i, _a);
            }

            undefined;
        }

        /*
         * Gets called for every matched result to match and show the list item
         *
         * @method checkMatchedResult
         * @public
         * @param {object} matching result
         */

    }, {
        key: 'checkMatchedResult',
        value: function checkMatchedResult(result) {
            return this.$searchableItems.find('[data-' + FILTER_FIELDS.USER_EMAIL + '=\'' + result.userEmail + '\']').parents('.js-filterSearch-item').removeClass(STATE_CLASSES.HIDDEN);
        }
    }]);
    return FilterSearchUsers;
}(_commonUi.FilterSearch);

exports.default = FilterSearchUsers;

},{"@amberhps/common-ui":"@amberhps/common-ui","babel-runtime/core-js/object/get-prototype-of":5,"babel-runtime/helpers/classCallCheck":10,"babel-runtime/helpers/createClass":11,"babel-runtime/helpers/inherits":14,"babel-runtime/helpers/possibleConstructorReturn":15,"jquery":"jquery"}]},{},[100]);
